export function CircleXIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      viewBox='0 0 24 24'
      {...props}
    >
      <circle cx='12' cy='12' r='10' />
      <path d='m15 9-6 6M9 9l6 6' />
    </svg>
  );
}
